<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="chtit"><b>CONTENTS</b></p>
<p class="toc1"><a href="#/chap01"><b>Editors’ Note</b></a></p>
<p class="toc"><a href="#/chap02"><b>Nayomi Munaweera</b>    Foreword</a></p>
<p class="toc"><a href="#/chap03"><b>Elmaz Abinader</b>    Your Spot on the Wall: Introduction</a></p>
<p class="toc1"><a href="#/chap04"><b>Devi S. Laskar</b>    gr<img alt="" src="images/e.jpg"/>-fē'tē    <i>poetry</i></a></p>
<p class="toc"><a href="#/chap05"><b>Monique Quintana</b>    Birthday Spells    <i>fiction</i></a></p>
<p class="toc"><span href="#/chap06" title="Link target outside of Sample"><b>Bhaskar Caduveti Rao</b>    The Face Reader    <i>fiction</i></span></p>
<p class="toc"><span href="#/chap07" title="Link target outside of Sample"><b>Kirin Khan</b>    In Public    <i>fiction</i></span></p>
<p class="toc"><span href="#/chap08" title="Link target outside of Sample"><b>Alycia Pirmohamed</b>    <i>poetry</i></span></p>
<p class="toc0"><span href="#/chap08" title="Link target outside of Sample">Letter to My Body</span></p>
<p class="toc0"><span href="#/chap09" title="Link target outside of Sample">We Have the Endings</span></p>
<p class="toc0"><span href="#/chap10" title="Link target outside of Sample">Twisted Wood</span></p>
<p class="toc"><span href="#/chap11" title="Link target outside of Sample"><b>Ramy El-Etreby</b>    My Life is a Tapestry    <i>nonfiction</i></span></p>
<p class="toc"><span href="#/chap12" title="Link target outside of Sample"><b>Gary Dauphin</b>    Suicide Jacq    <i>fiction</i></span></p>
<p class="toc"><span href="#/chap13" title="Link target outside of Sample"><b>Laura Lucas</b>    Nilscape    <i>fiction</i></span></p>
<p class="toc"><span href="#/chap14" title="Link target outside of Sample"><b>Vickie Vértiz</b>    Winning Prizes for Just Living    <i>nonfiction</i></span></p>
<p class="toc"><span href="#/chap15" title="Link target outside of Sample"><b>Natalie Graham</b>    Unburning the Body    <i>poetry</i></span></p>
<p class="toc"><span href="#/chap16" title="Link target outside of Sample"><b>Pallavi Dhawan</b>    Stranded    <i>nonfiction</i></span></p>
<p class="toc"><span href="#/chap17" title="Link target outside of Sample"><b>L. Penelope</b>    Loop    <i>fiction</i></span></p>
<p class="toc"><span href="#/chap18" title="Link target outside of Sample"><b>Tongo Eisen-Martin</b>    <i>poetry</i></span></p>
<p class="toc0"><span href="#/chap18" title="Link target outside of Sample">Cut A Hand From A Hand</span></p>
<p class="toc0"><span href="#/chap19" title="Link target outside of Sample">may we all refuse to die at the same time</span></p>
<p class="toc0"><span href="#/chap20" title="Link target outside of Sample">Channels to fall asleep to</span></p>
<p class="toc"><span href="#/chap21" title="Link target outside of Sample"><b>Lin Y. Leong</b>    The Girl and the Moth    <i>fiction</i></span></p>
<p class="toc"><span href="#/chap22" title="Link target outside of Sample"><b>Sarah LaBrie</b>    On Writing    <i>nonfiction</i></span></p>
<p class="toc"><span href="#/chap23" title="Link target outside of Sample"><b>Cynthia Alessandra Briano</b>    <i>poetry</i></span></p>
<p class="toc0"><span href="#/chap23" title="Link target outside of Sample">To Maria, Mi Fea, Love, Jesse</span></p>
<p class="toc0"><span href="#/chap24" title="Link target outside of Sample">To Jesse, Love, Maria Guadalupe A.</span></p>
<p class="toc"><span href="#/chap25" title="Link target outside of Sample"><b>Tamika Thompson</b>    In a Hard Man’s Town    <i>fiction</i></span></p>
<p class="toc"><span href="#/chap26" title="Link target outside of Sample"><b>Kay Ulanday Barrett</b>    <i>poetry</i></span></p>
<p class="toc0"><span href="#/chap26" title="Link target outside of Sample">While looking at photo albums</span></p>
<p class="toc0"><span href="#/chap27" title="Link target outside of Sample">Rhythm is a Dancer, Again</span></p>
<p class="toc"><span href="#/chap28" title="Link target outside of Sample"><b>Kanika Punwani</b>    Sister    <i>nonfiction</i></span></p>
<p class="toc1"><span href="#/chap29" title="Link target outside of Sample"><b>Contributor Biographies</b></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2c40891d